import { ConfirmDialog } from '@core/components';
import { useConfirmDialog } from '@core/hooks/useConfirmDialog';
import { type Order, undoCancelOrder } from '../../api/order';

interface UndoCancelDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order | null;
  onSuccess?: () => void;
}

const UndoCancelDialog = ({
  open,
  onClose,
  order,
  onSuccess,
}: UndoCancelDialogProps) => {
  const { loading, confirm, cancel } = useConfirmDialog({
    open,
    onClose,
    onConfirm: async () => {
      if (!order) return;
      await undoCancelOrder(order.id);
    },
    onSuccess,
    successMessage: 'Cancel undone',
    errorMessage: 'Failed to undo cancel',
  });

  return (
    <ConfirmDialog
      open={open}
      title="Undo cancel"
      content="This order will be restored to its previous production status. Continue?"
      confirmText="Undo"
      cancelText="Keep"
      onConfirm={confirm}
      onCancel={cancel}
      loading={loading}
    />
  );
};

export default UndoCancelDialog;
